import { Form, Button, Space } from '@arco-design/web-react'
import useLocale from '@/utils/useLocale'
import CustomInput from '@/components/CustomInput'

import styles from './style/index.module.less'
import Link from 'next/link'
import { useRouter } from 'next/router'
import useFormLogin from '@/hooks/useFormLogin'
import { emailFormValidator } from '@/utils'
import useLang from '@/utils/useLang'

const initialValues = { email: '', password: '' }

export default function LoginForm({ onChangeForm }: { onChangeForm: (v: 'email' | 'phone') => void }) {
  const [form] = Form.useForm()

  const router = useRouter()

  const t = useLocale()
  const lang = useLang()
  const isChinese = lang === 'zh-CN'
  // let captcha

  const { onSubmitClick, loading } = useFormLogin({
    form
  })

  return (
    <div className={styles['login-form-wrapper']}>
      <Form form={form} className={styles['login-form']} layout="vertical" initialValues={initialValues} size="large">
        <Form.Item
          label={t['login.form.email.placeholder']}
          field="email"
          rules={[{ required: true, validator: emailFormValidator, message: t['login.form.email.errMsg'] }]}
        >
          <CustomInput type="email" placeholder={t['login.form.email.placeholder']} />
        </Form.Item>
        <Form.Item
          label={t['login.form.password.label']}
          field="password"
          rules={[{ required: true, message: t['login.form.password.errMsg'] }]}
        >
          <CustomInput type="password" placeholder={t['login.form.password.placeholder']} />
        </Form.Item>

        <Space size={16} direction="vertical">
          <div className={styles['login-form-password-actions']}>
            <Link href="/forgot-password">{t['login.form.forgetPassword']}</Link>
            <span className={styles.emailLogin} onClick={(v) => onChangeForm?.('phone')}>
              {t['phone_login']}
            </span>
          </div>
          <Button
            type="primary"
            long
            loading={loading}
            className={styles['login-form-btn']}
            id="captcha-button"
            onClick={onSubmitClick}
          >
            {t['login.form.login']}
          </Button>
        </Space>
        <div style={{ color: '#A7A9C1', marginTop: '8px' }}>
          {t['login.no.account']}
          <span
            style={{ color: '#655AEC', cursor: 'pointer', marginLeft: '4px' }}
            onClick={() => {
              router.push('/register')
            }}
          >
            {t['login.signUp']}
          </span>
        </div>
      </Form>
    </div>
  )
}
